import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError, filter, first, tap } from 'rxjs';
import { AlertService } from './services/alert.service';

export const lockedOutInterceptor: HttpInterceptorFn = (req, next) => {
    const router = inject(Router);
    const alertService = inject(AlertService);
    return next(req).pipe(
        catchError((error: HttpErrorResponse) => {
            if ( error.status != null) {
                if (error.status == 423) { // Error type for being locked out (returned when 2fa has been failed too many times)
                    // Clear the local storage and cookies to prevent the user from being able to access the site without logging in again
                    localStorage.clear();
                    document.cookie = 'token=;';
                    document.cookie = 'expires=;';

                    if (router.url.includes('/manage-my-membership')) { // login page will handle the alerts itself
                        router.navigate(['login']);
                        alertService.error(error.error[""]);
                    }
                }
            }

            return throwError(() => error);
        }),
    );
};